import { ClientGuard } from './client/client.guard';
import { DataGuard } from './data/data.guard';
import { GiftingEligibilityGuard } from './eligibility/gifting-eligibility/gifting-eligibility.guard';
import { InheritanceEligibilityGuard } from './eligibility/inheritance-eligibility/inheritance-eligibility.guard';
import { MinorEligibilityGuard } from './eligibility/minor-eligibility/minor-eligibility.guard';
import { GatekeeperGuard } from './gatekeeper/gatekeeper.guard';
import { IncapacitatedGuard } from './incapacitated/incapacitated.guard';
import { LaunchGuard } from './launch/launch.guard';
import { TriageGuard } from './triage/triage.guard';

export const guards: any[] = [
  ClientGuard,
  DataGuard,
  GatekeeperGuard,
  GiftingEligibilityGuard,
  IncapacitatedGuard,
  InheritanceEligibilityGuard,
  LaunchGuard,
  MinorEligibilityGuard,
  TriageGuard,
];

export * from './client/client.guard';
export * from './data/data.guard';
export * from './gatekeeper/gatekeeper.guard';
export * from './incapacitated/incapacitated.guard';
export * from './launch/launch.guard';
export * from './eligibility/internal-transfer/internal-transfer.guard';
export * from './eligibility/inheritance-eligibility/inheritance-eligibility.guard';
export * from './eligibility/gifting-eligibility/gifting-eligibility.guard';
export * from './eligibility/minor-eligibility/minor-eligibility.guard';
export * from './experimentation/experimentation.guard';
export * from './triage/triage.guard';
